import React from "react";
import Text from "../typography/Text";
import File from "./File";
import Youtube from "./Youtube";
import Image from "../images/Image";

const Tool = ({ title, image, description, file, youtube, modified }) => {
  return (
    <div className="tool">
      {image && image.base_path ? (
        <div className="tool_image">
          <Image image={image} alt={image ? image.alt : ""} />
        </div>
      ) : (
        <div className="tool_image -empty" />
      )}
      <div className="tool_content">
        <h4 className="tool_title">{title ? title.rendered : ""}</h4>
        <div className="tool_description">
          <Text>{description}</Text>
        </div>
        {youtube && <Youtube {...youtube} />}
        {file && (!youtube || !youtube.link) && <File {...file} />}
        <div className="tool_modified">
          <Text superSmall>
            Last update:{" "}
            {new Date(
              file && !youtube ? file.modified : modified
            ).toLocaleDateString()}
          </Text>
        </div>
      </div>
    </div>
  );
};

export default Tool;
